import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { listAnatomy as parts } from "@chakra-ui/anatomy";
import { mode } from "@chakra-ui/theme-tools";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const variants = {
	orange: definePartsStyle((props) => ({
		item: {
			"&::marker": {
				color: mode("orange.500", "orange.200")(props),
				fontSize: "21px"
			}
		}
	}))
};

export const ListsTheme = defineMultiStyleConfig({ variants });
